import {
  AfterViewInit,
  ComponentRef,
  Directive,
  ElementRef,
  HostListener,
  Input,
  OnChanges, SimpleChanges,
  ViewContainerRef
} from '@angular/core';
import {ItemActionElement} from "../atoms/item-actions/item-action-element";
import {ItemActionsComponent} from "../atoms/item-actions/item-actions.component";
import {ItemActionsService} from "../atoms/item-actions/item-actions.service";
import {OverlayService} from "../overlay/overlay.service";

@Directive({
  selector: '[brtItemActions]'
})
export class ItemActionsDirective implements AfterViewInit, OnChanges {

  @Input('items') set setItems(val: ItemActionElement[]) {
    this.items = val;
  };

  items: ItemActionElement[] = [];
  @Input('title') title: string = "Aktionen";
  @Input('add-hover-effect') addHoverEffect: boolean = false;
  @Input("trigger-type") triggerType: "click" | "hover" = "click";
  createdComponent: ComponentRef<ItemActionsComponent> | null = null;
  mouseLeaveTimeout = -1;
  constructor(public el: ViewContainerRef, private itemActions: ItemActionsService, private overlay: OverlayService) { }
  @HostListener("mouseenter", ['$event'])
  private onMouseEnter($event: MouseEvent) {
    if(this.triggerType === "hover") {

      $event.stopPropagation();
      $event.preventDefault();
      clearTimeout(this.mouseLeaveTimeout);
      if(this.createdComponent === null) {
        this.itemActions.activate(this);
      }
    }
  }

  @HostListener("mouseleave", ['$event'])
  private onMouseLeave($event: MouseEvent) {
    if(this.triggerType === "hover") {
      $event.stopPropagation();
      $event.preventDefault();

      this.mouseLeaveTimeout = window.setTimeout(() => {
        // this.itemActions.activate(this);
        this.itemActions.deactivate(this);

      }, 300);
    }
  }

  @HostListener("click", ['$event'])
  private onClick($event: MouseEvent) {
    if(this.triggerType === "click") {
      $event.stopPropagation();
      $event.preventDefault();
      this.itemActions.activate(this);
    }
  }

  @HostListener('keydown', ['$event'])
  private onKeyDown($event: KeyboardEvent) {
    if (($event.target as HTMLElement).closest("brt-item-actions")) {
      return;
    }
    $event.stopPropagation();
    $event.stopImmediatePropagation();
    if($event.key === "Enter") {
      this.itemActions.activate(this);
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if(this.createdComponent !== null){
      this.createdComponent.setInput("menu-items", this.items);
      this.createdComponent.setInput("title", this.title);
    }

  }

  ngAfterViewInit() {
    const hostHtmlEl = this.el.element.nativeElement as HTMLElement;

    if(hostHtmlEl.style.position === "" || hostHtmlEl.style.position === "static") {
      hostHtmlEl.style.position = "relative";
    }

    if(this.addHoverEffect) {
      hostHtmlEl.classList.add("item-action-trigger");
    }

    // console.log(hostHtmlEl);
    hostHtmlEl.addEventListener("focusout", ($event: FocusEvent) => {
      // console.log($event);

      if($event.relatedTarget) {
        if(!hostHtmlEl.contains($event.relatedTarget as HTMLElement)) {
          this.hide();
        }
      }
    });
  }

  show() {
    if(window.innerWidth >= 992) {
      this.createdComponent = this.el.createComponent(ItemActionsComponent);
      this.createdComponent.setInput("menu-items", this.items);
      this.createdComponent.setInput("title", this.title);
      this.createdComponent.setInput("associatedDirective", this);
      const hostHtmlEl = this.el.element.nativeElement as HTMLElement;
      hostHtmlEl.append(this.createdComponent.location.nativeElement);

      console.log(hostHtmlEl);

      if(this.triggerType === 'click') {
        document.addEventListener("click", this.itemActions.onExternalCloseTriggerHandler);
      }
      document.addEventListener("scroll", this.itemActions.onExternalCloseTriggerHandler);
    } else {
      this.overlay.openWindowOverlay({
        title: this.title,
        componentMain: {
          component: ItemActionsComponent,
          data: {
            'menu-items': this.items,
            // title: this.title,
            associatedDirective: this
          }
        }
      })
    }

  }

  hide() {
    this.createdComponent?.destroy();
    this.createdComponent = null;
  }
}
